<template>
  <v-app>
    <v-main id="main-div">
      <div id="main-container">
        <div class="py-5 px-5 my-div">
          <a href="http://www.pori.or.id/" target="_blank">
            <v-img
              id="pori-logo"
              class="image-wiggle"
              :src="require('./assets/pori_logo.png')"
            ></v-img>
          </a>
        </div>

        <div class="py-5 px-5 top-offset-8">
          <v-layout class="justify-center">
            <div>
              <v-img
                id="cancer-icon"
                :src="require('./assets/cancer_icon.svg')"
              ></v-img>
            </div>
          </v-layout>
          <v-layout class="justify-center">
            <div class="text-center">
              <p class="title">Peta Persebaran</p>
              <p class="title title-boxed px-5">Onkologi Radiasi</p>
              <p class="title">Terintegrasi</p>
              <p class="subtitle">
                by Perhimpunan Dokter Spesialis Onkologi Radiasi Indonesia
                (PORI)
              </p>
            </div>
          </v-layout>
        </div>
        <v-img
          :src="require('./assets/map_bg.svg')"
          class="top-offset-12 at"
          ref="animatedDiv2"
        ></v-img>
        <v-layout class="justify-center top-offset-6">
          <v-dialog transition="dialog-top-transition" width="auto">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                class="search-button"
                @click="findNearestHospital"
                >TEMUKAN SENTER RADIOTERAPI TERDEKAT</v-btn
              >
            </template>
            <template v-slot:default="{ isActive }">
              <v-card id="nearest-location-popup">
                <!-- Header -->
                <div class="popup-header">
                  <div class="popup-header-content">
                    <v-icon class="mr-2" color="white" size="20">mdi-map-marker-radius</v-icon>
                    <span class="popup-header-title">3 Senter Terdekat</span>
                  </div>
                  <v-btn icon variant="text" color="white" @click="isActive.value = false" size="small" density="comfortable">
                    <v-icon size="20">mdi-close</v-icon>
                  </v-btn>
                </div>

                <!-- Loading -->
                <div class="popup-scroll-content" v-if="nearestHospital.length == 0">
                  <div class="loading-container py-8">
                    <img
                      src="https://www.icegif.com/wp-content/uploads/2023/07/icegif-1263.gif"
                      alt="Loading"
                    />
                    <p class="popup-loading-title">Mendeteksi lokasi Anda...</p>
                    <p class="popup-loading-sub">Pastikan browser dapat mengakses lokasi Anda</p>
                  </div>
                </div>

                <!-- Results -->
                <div class="popup-scroll-content" v-if="nearestHospital.length > 0">
                  <div
                    v-for="(hospital, index) in nearestHospital"
                    :key="index"
                    class="hospital-result-card"
                  >
                    <div class="hospital-rank-badge">{{ index + 1 }}</div>
                    <div class="hospital-result-name">{{ hospital.nama_rs }}</div>
                    <div class="hospital-result-meta">
                      <v-icon size="13" class="mr-1" style="opacity:0.6">mdi-map-marker</v-icon>{{ hospital.Provinsi }}
                      &nbsp;·&nbsp;{{ hospital.kepemilikan }}
                    </div>

                    <div class="hospital-services">
                      <span class="service-chip" :class="hospital.radiasi_eksterna ? 'chip-green' : 'chip-red'">
                        Radiasi Eksterna
                      </span>
                      <span class="service-chip" :class="hospital.brakhiterapi ? 'chip-green' : 'chip-red'">
                        Brakhiterapi
                      </span>
                      <span class="service-chip" :class="hospital.bpjs ? 'chip-green' : 'chip-red'">
                        BPJS
                      </span>
                    </div>

                    <div class="hospital-waittime">
                      <div class="waittime-item">
                        <span class="waittime-label">Radiasi Eksterna</span>
                        <span class="waittime-value">{{ hospital.waiting_externa ? hospital.waiting_externa : 'Belum tersedia' }}</span>
                      </div>
                      <div class="waittime-item">
                        <span class="waittime-label">Brachyteraphy</span>
                        <span class="waittime-value">{{ hospital.waiting_brachyteraphy ? hospital.waiting_brachyteraphy : 'Belum tersedia' }}</span>
                      </div>
                      <div class="waittime-item waittime-update">
                        <span class="waittime-label">Diperbarui</span>
                        <span class="waittime-value">{{ hospital.last_updated }}</span>
                      </div>
                    </div>

                    <a :href="hospital.link" target="_blank" class="hospital-location-btn">
                      <v-icon size="15" class="mr-1">mdi-directions</v-icon>
                      Buka di Maps
                    </a>
                  </div>
                </div>
              </v-card>
            </template>
          </v-dialog>
        </v-layout>
      </div>
      <v-container class="spacer-3"></v-container>
      <v-container class="spacer-3"></v-container>
      <v-container id="map-container">
        <div class="section-label-box text-center pb-5">
          <p class="section-chip">PETA INTERAKTIF</p>
          <p class="section-heading">Sebaran Senter Radioterapi Indonesia</p>
        </div>
        <div class="map-wrapper">
          <HospitalMap />
        </div>
      </v-container>
      <v-container class="spacer-3"></v-container>
      <v-container id="table-container">
        <v-container id="table-box">
          <div class="section-label-box text-center pb-2 pt-2">
            <p class="section-chip">DATA LENGKAP</p>
            <p class="section-heading">Daftar Senter Radioterapi</p>
          </div>
          <v-container id="search-container">
            <v-text-field
              v-model="search"
              label="Search"
              placeholder="Search by hospital name, province, or ownership"
              append-icon="mdi-magnify"
              single-line
              hide-details
            ></v-text-field>
          </v-container>
          <br>
          <div v-if="centersLoading" class="text-center pa-8">
            <v-progress-circular indeterminate color="primary" class="mb-3"></v-progress-circular>
            <p style="color: #666">Memuat data senter radioterapi...</p>
          </div>
          <div v-else-if="centersError" class="text-center pa-8">
            <v-icon size="40" color="red-darken-2" class="mb-2">mdi-alert-circle-outline</v-icon>
            <p style="color: #c00"><strong>Data senter radioterapi tidak dapat dimuat saat ini.</strong></p>
            <p style="color: #888; font-size: 13px">Silakan coba beberapa saat lagi.</p>
          </div>
          <v-data-table v-else :headers="headers" :items="filteredCentersData">
            <template v-slot:[`item.nama_rs`]="{ item }">
              <span>{{ item.nama_rs }}</span>
            </template>
            <template v-slot:[`item.position`]="{ item }">
              <a :href="item.link" target="_blank">Lokasi</a>
            </template>
            <template v-slot:[`item.Provinsi`]="{ item }">
              <span>{{ item.Provinsi }}</span>
            </template>
            <template v-slot:[`item.kepemilikan`]="{ item }">
              <span>{{ item.kepemilikan }}</span>
            </template>
            <template v-slot:[`item.radiasi_eksterna`]="{ item }">
              <span :style="item.radiasi_eksterna ? 'color: green' : ''">
                {{ item.radiasi_eksterna ? "🟢" : "🔴" }}
              </span>
            </template>
            <template v-slot:[`item.brakhiterapi`]="{ item }">
              <span :style="item.brakhiterapi ? 'color: green' : ''">
                {{ item.brakhiterapi ? "🟢" : "🔴" }}
              </span>
            </template>
            <template v-slot:[`item.bpjs`]="{ item }">
              <span :style="item.bpjs ? 'color: green' : 'color: red'">
                {{ item.bpjs ? "🟢" : "🔴" }}
              </span>
            </template>
            <template v-slot:[`item.waiting_externa`]="{ item }">
              <span>{{ item.waiting_externa ? item.waiting_externa : 'Info belum tersedia' }}</span>
            </template>
            <template v-slot:[`item.waiting_brachyteraphy`]="{ item }">
              <span>{{ item.waiting_brachyteraphy ? item.waiting_brachyteraphy : 'Info belum tersedia' }}</span>
            </template>
            <template v-slot:[`item.last_updated`]="{ item }">
              <span>{{ item.last_updated }}</span>
            </template>
          </v-data-table>
        </v-container>
      </v-container>
      <v-container class="spacer-3"></v-container>
      <v-container id="doctors-container">
        <v-container id="doctors-box">
          <div class="section-label-box text-center pb-2 pt-4">
            <p class="section-chip">ANGGOTA PORI</p>
            <p class="section-heading">Daftar Dokter PORI</p>
          </div>
          <v-container id="doctors-search-container">
            <v-text-field
              v-model="doctorSearch"
              placeholder="Cari berdasarkan nama, lokasi praktik, provinsi, atau subspesialisasi"
              append-inner-icon="mdi-magnify"
              single-line
              hide-details
              rounded="lg"
              variant="outlined"
              bg-color="white"
              density="comfortable"
            ></v-text-field>
          </v-container>
          <br />
          <div v-if="membersLoading" class="text-center pa-8">
            <v-progress-circular indeterminate color="primary" class="mb-3"></v-progress-circular>
            <p style="color: #666">Memuat data dokter...</p>
          </div>
          <div v-else-if="membersError" class="text-center pa-8">
            <v-icon size="40" color="red-darken-2" class="mb-2">mdi-alert-circle-outline</v-icon>
            <p style="color: #c00"><strong>Data dokter tidak dapat dimuat saat ini.</strong></p>
            <p style="color: #888; font-size: 13px">Silakan coba beberapa saat lagi.</p>
          </div>
          <div v-else-if="membersData.length === 0" class="text-center pa-8">
            <p style="color: #666">Belum ada data dokter yang tersedia.</p>
          </div>
          <v-row v-else class="pa-2">
            <v-col
              v-for="(doctor, index) in paginatedMembersData"
              :key="index"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <v-card class="doctor-card" height="100%">
                <div class="doctor-photo-wrap">
                  <v-img :src="getDoctorPhotoUrl(doctor.photo)" height="180" cover>
                    <template v-slot:placeholder>
                      <div class="doctor-photo-placeholder d-flex align-center justify-center">
                        <v-icon size="64" color="blue-lighten-3">mdi-account-circle</v-icon>
                      </div>
                    </template>
                    <template v-slot:error>
                      <div class="doctor-photo-placeholder d-flex align-center justify-center">
                        <v-icon size="64" color="blue-lighten-3">mdi-account-circle</v-icon>
                      </div>
                    </template>
                  </v-img>
                </div>
                <v-card-text class="pt-3 pb-1">
                  <div class="doctor-name mb-1">{{ doctor.name }}</div>
                  <div class="doctor-member-number mb-2">{{ doctor.member_number }}</div>
                  <div class="mb-2" v-if="doctor.subspecializations && doctor.subspecializations.length">
                    <v-chip
                      v-for="(spec, si) in doctor.subspecializations"
                      :key="si"
                      size="x-small"
                      color="primary"
                      variant="tonal"
                      class="mr-1 mb-1"
                    >{{ spec }}</v-chip>
                  </div>
                </v-card-text>
                <v-divider class="mx-3" opacity="0.08"></v-divider>
                <v-card-text class="pt-2 pb-3">
                  <div v-if="doctor.public_contact" class="doctor-info-row mb-1">
                    <v-icon size="14" color="blue-darken-2" class="mr-1">mdi-phone</v-icon>
                    <span>{{ doctor.public_contact }}</span>
                  </div>
                  <div v-if="doctor.provinsi" class="doctor-info-row mb-2">
                    <v-icon size="14" color="blue-darken-2" class="mr-1">mdi-map-marker</v-icon>
                    <span>
                      <span v-if="doctor.kabupaten">{{ doctor.kabupaten.name }}, </span>{{ doctor.provinsi.name }}
                    </span>
                  </div>
                  <div v-if="doctor.practice_locations && doctor.practice_locations.length > 0" class="mt-1">
                    <div class="doctor-practice-label mb-1">Lokasi Praktik:</div>
                    <div
                      v-for="(loc, li) in doctor.practice_locations"
                      :key="li"
                      class="doctor-practice-item"
                    >
                      <div class="doctor-practice-name">{{ loc.hospital }}</div>
                      <div
                        v-for="(sch, si) in loc.schedules"
                        :key="si"
                        class="doctor-practice-schedule"
                      >{{ sch }}</div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <div v-if="totalDoctorPages > 1" class="d-flex justify-center pt-2 pb-4">
            <v-pagination
              v-model="doctorPage"
              :length="totalDoctorPages"
              :total-visible="7"
              color="primary"
              rounded="circle"
            ></v-pagination>
          </div>
          <div v-if="membersData.length > 0 && filteredMembersData.length === 0" class="text-center pa-8">
            <v-icon size="40" color="blue-lighten-3" class="mb-2">mdi-account-search-outline</v-icon>
            <p style="color: #666">Tidak ada dokter yang sesuai dengan pencarian.</p>
          </div>
        </v-container>
      </v-container>
      <v-container class="spacer-3"></v-container>
      <div id="ribbon-container" class="d-flex">
        <div>
          <v-img id="ribbon-img" :src="require('./assets/ribbon.png')"> </v-img>
        </div>

        <div id="ribbon-content" class="d-flex align-center">
          <div>
            <p id="ribbon-title">
              Peta Persebaran Senter Radioterapi di Indonesia
            </p>
            <p id="ribbon-desc">
              Berdiri sejak tahun 2000, Perhimpunan Dokter Spesialis Onkologi
              Radiasi Indonesia (PORI) terus berupaya dalam memenuhi kebutuhan
              masyarakat Indonesia akan pelayanan radioterapi baik dalam hal
              pengadaan sarana dan prasarana maupun dalam pemenuhan kebutuhan
              dokter spesialis onkologi radiasi. Dengan adanya Peta Persebaran
              Senter Radioterapi di Indonesia, kami berharap dapat mendekatkan
              dan mempermudah akses pelayanan radioterapi kepada masyarakat
              sehingga dapat mencapai tujuan <i>close the care gap</i> pada
              pelayanan radioterapi sesuai dengan fokus onkologi global saat
              ini.
            </p>
          </div>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import HospitalMap from "./components/HospitalMap";
import axios from "axios";

export default {
  name: "App",

  components: {
    HospitalMap,
  },

  data: () => ({
    search: "",
    doctorSearch: "",
    doctorPage: 1,
    doctorPageSize: 12,
    nearestHospital: [],
    headers: [
      {
        title: "Rumah Sakit",
        align: "start",
        value: "nama_rs",
        sortable: true,
      },
      { title: "Lokasi", value: "position", sortable: true },
      { title: "Provinsi", value: "Provinsi", sortable: true },
      { title: "Kepemilikan", value: "kepemilikan", sortable: true },
      { title: "Radiasi Eksterna", value: "radiasi_eksterna", sortable: true },
      { title: "Brakhiterapi", value: "brakhiterapi", sortable: true },
      { title: "Praktek BPJS", value: "bpjs", sortable: true },
      { title: "Waktu Tunggu Radiasi Eksterna", value: "waiting_externa", sortable: true },
      { title: "Waktu Tunggu Brachyteraphy", value: "waiting_brachyteraphy", sortable: true },
      { title: "Tanggal Update", value: "last_updated", sortable: true },
    ],
  }),

  mounted() {
    this.$store.dispatch("fetchRadiotherapyCenters");
    this.$store.dispatch("fetchMembersData");
  },

  computed: {
    centersData() {
      return this.$store.state.centersData;
    },
    centersLoading() {
      return this.$store.state.centersLoading;
    },
    centersError() {
      return this.$store.state.centersError;
    },
    filteredCentersData() {
      if (!this.search) {
        return this.centersData;
      }
      const searchTerm = this.search.toLowerCase();
      return this.centersData.filter((hospital) => {
        return (
          hospital.nama_rs.toLowerCase().includes(searchTerm) ||
          hospital.Provinsi.toLowerCase().includes(searchTerm) ||
          hospital.kepemilikan.toLowerCase().includes(searchTerm)
        );
      });
    },
    membersData() {
      return this.$store.state.membersData;
    },
    membersLoading() {
      return this.$store.state.membersLoading;
    },
    membersError() {
      return this.$store.state.membersError;
    },
    filteredMembersData() {
      if (!this.doctorSearch) return this.membersData;
      const term = this.doctorSearch.toLowerCase();
      return this.membersData.filter((d) =>
        d.name.toLowerCase().includes(term) ||
        (d.provinsi?.name || '').toLowerCase().includes(term) ||
        (d.kabupaten?.name || '').toLowerCase().includes(term) ||
        (d.subspecializations || []).some((s) => s.toLowerCase().includes(term)) ||
        (d.practice_locations || []).some((loc) => loc.hospital.toLowerCase().includes(term))
      );
    },
    paginatedMembersData() {
      const start = (this.doctorPage - 1) * this.doctorPageSize;
      return this.filteredMembersData.slice(start, start + this.doctorPageSize);
    },
    totalDoctorPages() {
      return Math.ceil(this.filteredMembersData.length / this.doctorPageSize);
    },
  },

  watch: {
    doctorSearch() {
      this.doctorPage = 1;
    },
  },

  methods: {
    findNearestHospital() {
      const getLocationPromise = new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        } else {
          reject(new Error("Geolocation is not supported by this browser."));
        }
      });

      const timeoutPromise = new Promise((resolve, reject) => {
        setTimeout(
          () => reject(new Error("Timeout waiting for location permission.")),
          7000
        );
      });

      Promise.race([getLocationPromise, timeoutPromise])
        .then((position) => {
          const userLocation = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          this.nearestHospital = this.getNearestHospitals(userLocation);
        })
        .catch((error) => {
          if (error.message === "Timeout waiting for location permission.") {
            axios
              .get(
                `https://api.ipdata.co?api-key=${process.env.VUE_APP_IPDATA_API_KEY}`
              )
              .then((response) => {
                const userLocation = {
                  latitude: response.data.latitude,
                  longitude: response.data.longitude,
                };
                this.nearestHospital = this.getNearestHospitals(userLocation);
              })
              .catch((err) => {
                console.error("Error fetching location - " + err.message);
              });
          } else {
            console.error("Error getting user location - " + error.message);
          }
        });
    },
    getNearestHospitals(userLocation) {
      const hospitalDistances = this.centersData.map((hospital) => {
        const distance = this.calculateDistance(
          userLocation.latitude,
          userLocation.longitude,
          hospital.position[0],
          hospital.position[1]
        );
        return { ...hospital, distance };
      });
      hospitalDistances.sort((a, b) => a.distance - b.distance);
      return hospitalDistances.slice(0, 3);
    },
    calculateDistance(lat1, lon1, lat2, lon2) {
      const R = 6371;
      const dLat = this.deg2rad(lat2 - lat1);
      const dLon = this.deg2rad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) *
          Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    },
    deg2rad(deg) {
      return deg * (Math.PI / 180);
    },
    getDoctorPhotoUrl(photo) {
      if (!photo) return null;
      // API returns http://localhost (port 80) but storage is served on :8000
      return photo.replace('http://localhost/', 'http://localhost:8000/');
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

/* === BASE === */
body {
  background-color: #f4f8ff !important;
  font-family: "Inter", sans-serif;
}

#main-div {
  background-color: #f4f8ff !important;
}

/* === HERO === */
#main-container {
  background: linear-gradient(150deg, #0b3d91 0%, #1565c0 30%, #1e88e5 65%, #56b4ff 100%);
  max-width: 100vw;
  margin: 0 !important;
  padding: 0 0 4vw 0 !important;
  font-family: "Inter", sans-serif;
  border-radius: 0 0 4vw 4vw;
  box-shadow: 0 16px 56px rgba(11, 61, 145, 0.32);
}

/* === TYPOGRAPHY === */
.title {
  font-weight: 600;
  color: white;
  font-size: clamp(28px, 4vw, 150px) !important;
  line-height: 1.2 !important;
  letter-spacing: -0.01em;
  font-family: "Inter", sans-serif;
}

.title-boxed {
  background: rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1.5px solid rgba(255, 255, 255, 0.32);
  border-radius: 10px;
  display: inline-block;
}

.subtitle {
  font-weight: 400;
  color: rgba(255, 255, 255, 0.82);
  font-size: clamp(12px, 1.4vw, 100px) !important;
  line-height: 1.65;
  font-family: "Inter", sans-serif;
}

/* === LOGOS === */
#pori-logo {
  width: 8vw;
  filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.2));
}

#cancer-icon {
  width: 4vw;
  filter: drop-shadow(0 2px 10px rgba(255, 255, 255, 0.3));
}

/* === SEARCH BUTTON === */
.search-button {
  font-weight: 600;
  color: white !important;
  background: linear-gradient(135deg, #c2185b 0%, #e91e63 60%, #f06292 100%) !important;
  border-radius: 1000px;
  padding: 1.2vw 3vw !important;
  box-shadow: 0 6px 28px rgba(194, 24, 91, 0.52) !important;
  height: unset !important;
  font-size: clamp(10px, 1.1vw, 38px) !important;
  letter-spacing: 0.07em;
  transition: box-shadow 0.3s ease, transform 0.25s ease !important;
  font-family: "Inter", sans-serif;
}

.search-button:hover {
  box-shadow: 0 10px 40px rgba(194, 24, 91, 0.68) !important;
  transform: translateY(-2px) !important;
}

/* === OFFSETS === */
.top-offset-6 {
  margin-top: -8vw;
}

.top-offset-8 {
  margin-top: -8vw;
}

.top-offset-12 {
  margin-top: -20vw;
}

/* === SPACERS === */
.spacer-title {
  height: 10vw;
  max-width: 100vw !important;
}

.spacer-3 {
  height: 3vw;
  background: #f4f8ff !important;
  max-width: 100vw !important;
}

.spacer-6 {
  height: 6vw;
  background: #eef4ff !important;
  max-width: 100vw !important;
}

/* === SECTION LABELS === */
.section-label-box {
  font-family: "Inter", sans-serif;
}

.section-chip {
  display: inline-block !important;
  background: #dbeafe;
  color: #1565c0;
  font-size: clamp(9px, 0.85vw, 28px) !important;
  font-weight: 600;
  letter-spacing: 0.12em;
  border-radius: 100px;
  padding: 0.35vw 1.2vw !important;
  margin-bottom: 0.6vw !important;
  text-transform: uppercase;
  font-family: "Inter", sans-serif;
}

.section-heading {
  font-size: clamp(18px, 2.4vw, 80px) !important;
  font-weight: 700;
  color: #0d47a1;
  letter-spacing: -0.01em;
  line-height: 1.2 !important;
  font-family: "Inter", sans-serif;
}

/* === MAP SECTION === */
#map-container {
  background: #f4f8ff;
  margin: 0 !important;
  padding: 3vw 5vw 4vw !important;
  max-width: 100vw;
}

.map-wrapper {
  border-radius: 1.8vw;
  overflow: hidden;
  box-shadow: 0 10px 48px rgba(11, 61, 145, 0.16);
}

/* === TABLE SECTION === */
#table-container {
  background: linear-gradient(180deg, #f4f8ff 0%, #eef4ff 100%);
  margin: 0 !important;
  padding: 0 0 3vw !important;
  max-width: 100vw;
  font-family: "Inter", sans-serif;
}

#table-box {
  background: white;
  border-radius: 2vw;
  max-width: 90vw;
  box-shadow: 0 4px 32px rgba(11, 61, 145, 0.09);
  padding: 2vw !important;
}

#search-container {
  padding: 0.5vw 1vw;
}

th > span {
  font-weight: 700;
  color: #1565c0;
  font-size: 0.78em;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* === DOCTORS SECTION === */
#doctors-container {
  background: linear-gradient(180deg, #eef4ff 0%, #f4f8ff 100%);
  margin: 0 !important;
  padding: 0 !important;
  font-family: "Inter", sans-serif;
  max-width: 100vw;
}

#doctors-box {
  background: white;
  border-radius: 2vw;
  max-width: 90vw;
  padding-bottom: 2vw !important;
  box-shadow: 0 4px 32px rgba(11, 61, 145, 0.09);
}

#doctors-search-container {
  padding: 0.5vw 1vw;
}

.doctor-card {
  border-radius: 16px !important;
  overflow: hidden;
  font-family: "Inter", sans-serif;
  box-shadow: 0 2px 16px rgba(11, 61, 145, 0.08) !important;
  transition: box-shadow 0.3s ease, transform 0.25s ease !important;
  border: 1px solid #e8f0ff !important;
}

.doctor-card:hover {
  box-shadow: 0 8px 32px rgba(11, 61, 145, 0.2) !important;
  transform: translateY(-4px);
}

.doctor-card-accent {
  height: 4px;
  background: linear-gradient(90deg, #1565c0 0%, #42a5f5 100%);
}

.doctor-photo-wrap {
  overflow: hidden;
}

.doctor-photo-placeholder {
  height: 180px;
  background: linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%);
}

.doctor-name {
  white-space: normal !important;
  word-break: break-word;
  font-size: clamp(13px, 1vw, 20px) !important;
  line-height: 1.4 !important;
  font-weight: 700 !important;
  color: #0d47a1 !important;
  font-family: "Inter", sans-serif;
}

.doctor-member-number {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 500;
  font-family: "Inter", sans-serif;
  letter-spacing: 0.02em;
}

.doctor-info-row {
  display: flex;
  align-items: flex-start;
  font-size: 12.5px;
  color: #475569;
  font-family: "Inter", sans-serif;
  line-height: 1.5;
}

.doctor-practice-label {
  font-size: 11.5px;
  font-weight: 700;
  color: #1e40af;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-family: "Inter", sans-serif;
}

.doctor-practice-item {
  background: #f8faff;
  border-radius: 8px;
  padding: 6px 10px;
  margin-bottom: 5px;
  border-left: 3px solid #93c5fd;
}

.doctor-practice-name {
  font-size: 12.5px;
  font-weight: 600;
  color: #1e3a5f;
  font-family: "Inter", sans-serif;
  line-height: 1.4;
}

.doctor-practice-schedule {
  font-size: 11px;
  color: #64748b;
  font-family: "Inter", sans-serif;
  margin-top: 1px;
}

/* === RIBBON SECTION === */
#ribbon-container {
  background: linear-gradient(135deg, #0b3d91 0%, #1565c0 45%, #1e88e5 80%, #42a5f5 100%);
  margin: 0 !important;
  padding: 0 !important;
  max-width: 100vw;
  font-family: "Inter", sans-serif;
}

#ribbon-title {
  font-weight: 700;
  color: white;
  font-size: clamp(15px, 2vw, 180px);
  padding-bottom: 1.5vw !important;
  letter-spacing: -0.01em;
  line-height: 1.2;
}

#ribbon-desc {
  font-weight: 400;
  color: rgba(255, 255, 255, 0.86);
  font-size: clamp(12px, 1.5vw, 100px);
  padding-bottom: 2vw !important;
  line-height: 1.8;
}

#ribbon-content {
  margin-left: -15vw;
  margin-right: 10vw;
  z-index: 1 !important;
}

#ribbon-img {
  width: 50vw;
}

@media (max-width: 768px) {
  #ribbon-container {
    flex-direction: column;
    padding: 8vw 6vw 10vw !important;
  }

  #ribbon-img {
    display: none;
  }

  #ribbon-content {
    margin-left: 0;
    margin-right: 0;
  }

  #ribbon-title {
    font-size: clamp(16px, 5vw, 28px);
    padding-bottom: 3vw !important;
  }

  #ribbon-desc {
    font-size: clamp(13px, 3.8vw, 18px);
  }
}

/* === POPUP === */
#nearest-location-popup {
  font-family: "Inter", sans-serif;
  border-radius: 20px !important;
  overflow: hidden;
  width: 460px;
  max-width: 95vw;
}

.popup-header {
  background: linear-gradient(135deg, #0b3d91 0%, #1e88e5 100%);
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.popup-header-content {
  display: flex;
  align-items: center;
}

.popup-header-title {
  color: white;
  font-weight: 700;
  font-size: 17px;
  font-family: "Inter", sans-serif;
  letter-spacing: -0.01em;
}

.popup-scroll-content {
  max-height: 72vh;
  overflow-y: auto;
  padding: 16px !important;
  scrollbar-width: thin;
  scrollbar-color: #bfdbfe transparent;
}

.popup-scroll-content::-webkit-scrollbar {
  width: 5px;
}

.popup-scroll-content::-webkit-scrollbar-track {
  background: transparent;
}

.popup-scroll-content::-webkit-scrollbar-thumb {
  background: #bfdbfe;
  border-radius: 10px;
}

.popup-loading-title {
  font-weight: 700;
  font-size: 15px;
  color: #1e293b;
  font-family: "Inter", sans-serif;
}

.popup-loading-sub {
  font-size: 13px;
  color: #64748b;
  font-family: "Inter", sans-serif;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.loading-container img {
  width: 160px;
  height: auto;
  border-radius: 12px;
}

/* Hospital Result Cards */
.hospital-result-card {
  background: #f8faff;
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 12px;
  border: 1px solid #dbeafe;
  position: relative;
}

.hospital-result-card:last-child {
  margin-bottom: 0;
}

.hospital-rank-badge {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #1565c0, #1e88e5);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
  font-family: "Inter", sans-serif;
}

.hospital-result-name {
  font-weight: 700;
  color: #0d47a1;
  font-size: 15px;
  line-height: 1.35;
  padding-right: 42px;
  font-family: "Inter", sans-serif;
  margin-bottom: 4px;
}

.hospital-result-meta {
  color: #64748b;
  font-size: 12.5px;
  font-family: "Inter", sans-serif;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.hospital-services {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}

.service-chip {
  font-size: 11.5px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  padding: 3px 10px;
  border-radius: 100px;
  letter-spacing: 0.01em;
}

.chip-green {
  background: #dcfce7;
  color: #15803d;
}

.chip-red {
  background: #fee2e2;
  color: #b91c1c;
}

.hospital-waittime {
  background: white;
  border-radius: 10px;
  padding: 10px 12px;
  border: 1px solid #e2eaff;
  margin-bottom: 10px;
}

.waittime-item {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 12.5px;
  font-family: "Inter", sans-serif;
  padding: 3px 0;
  border-bottom: 1px solid #f0f4ff;
}

.waittime-item:last-child {
  border-bottom: none;
}

.waittime-update {
  opacity: 0.7;
  font-size: 11.5px;
}

.waittime-label {
  color: #64748b;
  font-weight: 500;
  flex-shrink: 0;
  margin-right: 12px;
}

.waittime-value {
  color: #1e293b;
  font-weight: 600;
  text-align: right;
}

.hospital-location-btn {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, #1565c0, #1e88e5);
  color: white !important;
  text-decoration: none !important;
  padding: 7px 16px;
  border-radius: 100px;
  font-size: 13px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  transition: opacity 0.2s ease, transform 0.2s ease;
  box-shadow: 0 3px 12px rgba(21, 101, 192, 0.35);
}

.hospital-location-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.v-card-title {
  white-space: wrap !important;
  font-weight: 600 !important;
  color: #0d47a1;
  font-family: "Inter", sans-serif;
}

/* === MISC === */
#map-iframe {
  width: 100vw;
  height: 50vw;
  margin: 0 !important;
  padding: 0 !important;
}

p {
  margin: 0 !important;
  padding: 0 !important;
}


@keyframes wiggle {
  0%, 100% { transform: rotate(-5deg); }
  50% { transform: rotate(5deg); }
}

.image-wiggle {
  transition: transform 0.2s ease-in-out;
  display: inline-block;
}

.image-wiggle:hover {
  animation: wiggle 0.5s ease-in-out infinite;
}
</style>
